import React, { useState } from "react";

import "./stylesLocationRestrictionsPopup.css";
import { Save, X } from "react-feather";
import SaveButton from "../../../CommonComponents/SaveButton/SaveButton";

function LocationRestrictionsPopup({
  isVisible,
  onClosePressed,
  getEventCodesList,
  game,
  name,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);
      await getEventCodesList();
      onClosePressed();
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClosePressed = () => {
    onClosePressed();
  };

  if (!isVisible) return null;
  return (
    <div className="location-restrictions-popup">
      <div className="location-restrictions-panel">
        <div className="location-restrictions-panel-header">
          <h2>remove this game?</h2>
          <button className="close-button" onClick={handleClosePressed}>
            <X className="close-icon" />
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <p>
            Are you sure you want to remove {game.name} from the {name}{" "}
            category?
          </p>
          <SaveButton
            isSubmitting={isSubmitting}
            buttonText="Yes, Remove"
            cancelButton={true}
            cancelButtonText="No"
            callbackFunction={handleSubmit}
            callbackFunctionCancel={handleClosePressed}
          />
        </form>
      </div>
    </div>
  );
}

export default LocationRestrictionsPopup;
